export interface LinkedInIconProps {
    className: string;
}

export function LinkedInIcon({className = ''}: LinkedInIconProps) {
    return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" className={`w-full ${className}`}>
        <path d="M2.99,5.99c1.65,0,2.99-1.34,2.99-2.99S4.64,0,2.99,0,0,1.34,0,2.99s1.34,2.99,2.99,2.99Z"/>
        <path d="M5.26,7.98H.72c-.12,0-.22.1-.22.22v14.52c0,.12.1.22.22.22h4.54c.12,0,.22-.1.22-.22v-14.52c0-.12-.1-.22-.22-.22Z"/>
        <path d="M22.43,13.47v8.48c0,.55-.45,1-1,1h-2.99c-.55,0-1-.45-1-1v-6.99c0-1.38-1.12-2.49-2.49-2.49s-2.49,1.12-2.49,2.49v6.99c0,.55-.45,1-1,1h-2.99c-.55,0-1-.45-1-1v-12.98c0-.55.45-1,1-1h2.99c.55,0,1,.45,1,1v.64c1-1.29,2.65-2.14,4.48-2.14,2.75,0,5.48,2,5.48,5.99Z"/>
    </svg>
    )
}